import { AdminPageShell } from "@/components/admin-page-shell";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { env } from "@/lib/env";

export function LoginPage() {
  useDocumentTitle("Login");

  return (
    <AdminPageShell className="max-w-xl py-12 lg:py-20">
      <div className="flex justify-center">
        <Card className="rounded-2xl border-neutral-100 p-8 shadow-sm">
          <div className="space-y-4">
            <h2 className="font-gotham text-2xl font-semibold text-neutral-900">
              Sign in with Sked Social
            </h2>
            <Button asChild className="w-full justify-center">
              <a
                href={new URL(
                  "/sked-link-sso",
                  env.schedugramServerBackendUrl
                ).toString()}
              >
                <i className="fa-solid fa-arrow-up-right-from-square" />
                Continue to Sked Social
              </a>
            </Button>
          </div>
        </Card>
      </div>
    </AdminPageShell>
  );
}
